import React from 'react'
import ReactDOM from 'react-dom'
import dotenv from 'dotenv'
import './styles/global.scss'
import Application from './application'

dotenv.config()

ReactDOM.render(<Application />, document.getElementById('root'))
